import axios from "axios";
import { toSnakeCase, toCamelCase } from "./data-format";
import { getToken, removeToken, setToken, getUserInfo, removeAll } from "@/utils/auth";
import { refresh } from "@/api/security";
import { Message } from "element-ui";
import router from "@/router";
import store from "@/store";
const http = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000,
});

// console.log(process.env.ENV)

http.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token != undefined) {
            config.headers.common["Authorization"] = `Bearer ${token}`;
        }
        config.headers.common["accept-language"] = store.getters.language;
        if (!config.unformat) {
            config.params = toSnakeCase(config.params);
            config.data = toSnakeCase(config.data);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

http.interceptors.response.use(
    (response) => {
        if (response.headers["content-type"] === "application/json") {
            response.data = toCamelCase(response.data);
        }
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            let d = {
                refreshToken: getUserInfo("refreshToken"),
            };
            refresh(d)
                .then((v) => {
                    setToken(v.data.accessToken);
                    setTimeout(() => {
                        let { hash } = location;
                        if (hash.indexOf("#/examination?") != 0) location.reload();
                    }, 1000);
                })
                .catch(() => {
                    removeToken();
                    removeAll();
                    window.sessionStorage.clear();
                    router.push({ path: "/login" });
                });
        } else if (error.response.status === 500) {
            if (error.response.data && error.response.data.message && error.response.data.message.indexOf("($") > 0) {
                // let regex = /(?<=\(\$)(.+?)(?=\))/g   // 匹配($XXXXX)里的XXXX
                let regex = new RegExp("(?<=\\(\\$)(.+?)(?=\\))", "g"); //兼容Safari
                let key = error.response.data.message.match(regex)[0];
                if (key == "refreshToken") console.log(error.response.data.message);
                else Message.error(error.response.data.message);
            } else console.log(error.response.data.message);
        } else if (
            error.response.data.error_code == "INVALID_USER_ACCOUNT" ||
            error.response.data.error_code == "INVALID_PARENT_PASSWORD" ||
            error.response.data.error_code == "INVALID_STUDENT_PASSWORD" ||
            error.response.data.error_code == "SUBSCRIPTION_EXPIRED_ERROR" ||
            error.response.data.error_code == "NO_SUBSCRIPTION_ERROR" ||
            error.response.data.error_code == "SUBSCRIPTION_NOT_START_ERROR" ||
            error.response.data.error_code == "AUTH_ERROR"
            // || error.response.data.error_message == '分校學生編號已被註冊'
        ) {
            console.log(error.response.data.error_message);
        } else {
            Message.error(error.response.data.error_message);
        }
        return Promise.reject(error);
    }
);

export default http;
